import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/route-guards/auth.guard';
import { TypeComponent } from './type/create-type/type.component';
import { TypeListComponent } from './type/type-list/type-list.component';

import { TagComponent } from './tag/create-tag/tag.component';
import { TagListComponent } from './tag/tag-list/tag-list.component';

const routes: Routes = [
  {
    path: 'type/add',
    component: TypeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'type/edit/:id',
    component: TypeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'type/list',
    component: TypeListComponent,
    canActivate: [AuthGuard]
  },{
    path: 'tag/add',
    component: TagComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'tag/edit/:id',
    component: TagComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'tag/list',
    component: TagListComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FiltersRoutingModule { }
